/**
 * Capacitor Native Bluetooth Adapter
 *
 * This adapter wraps a Capacitor Bluetooth plugin for native iOS/Android.
 * Currently a placeholder - will be implemented when a compatible plugin is added.
 *
 * For now, native apps will fall back to Web Bluetooth in the WebView.
 */

import { Capacitor } from '@capacitor/core'
import type { PrinterAdapter, PrinterDevice } from '../types'

export class CapacitorBluetoothAdapter implements PrinterAdapter {
  private connectedDevice: PrinterDevice | null = null

  /**
   * Check if this adapter should be used
   */
  static isSupported(): boolean {
    return Capacitor.isNativePlatform()
  }

  /**
   * Check if the native plugin is available
   */
  static isPluginAvailable(): boolean {
    // TODO: Check for actual plugin availability when implemented
    return false
  }

  async scan(): Promise<PrinterDevice[]> {
    if (!CapacitorBluetoothAdapter.isPluginAvailable()) {
      console.warn('[CapacitorBluetooth] Native plugin not available')
      return []
    }

    // TODO: Implement native scanning when plugin is available
    return []
  }

  async connect(deviceId: string): Promise<boolean> {
    if (!CapacitorBluetoothAdapter.isPluginAvailable()) {
      throw new Error('Native Bluetooth plugin not available')
    }

    console.log('[CapacitorBluetooth] Would connect to:', deviceId)
    return false
  }

  async disconnect(): Promise<void> {
    if (!CapacitorBluetoothAdapter.isPluginAvailable()) {
      return
    }

    this.connectedDevice = null
  }

  async isConnected(): Promise<boolean> {
    if (!CapacitorBluetoothAdapter.isPluginAvailable()) {
      return false
    }

    return this.connectedDevice?.connected || false
  }

  getConnectedDevice(): PrinterDevice | null {
    return this.connectedDevice
  }

  async print(data: Uint8Array): Promise<boolean> {
    if (!CapacitorBluetoothAdapter.isPluginAvailable()) {
      throw new Error('Native Bluetooth plugin not available')
    }

    console.log('[CapacitorBluetooth] Would print', data.length, 'bytes')
    return false
  }
}
